import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import LessonDemo from './LessonDemo';
import { DEMO_SCENE_TOPICS, getDemoSceneTopicByKey } from '../data/demoSceneRequests';

const SceneLessonPage = ({ useStaticDemo = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search || '');
  const forceStatic = params.get('static') === '1';
  const forceLive = params.get('live') === '1';
  const demoTopicKey = params.get('topic') || 'ai';
  const useStaticScene = (useStaticDemo || forceStatic) && !forceLive;
  const selectedDemoTopic = getDemoSceneTopicByKey(demoTopicKey);
  const demoTopicOptions = DEMO_SCENE_TOPICS.map((t) => ({ key: t.key, label: t.label }));

  const handleDemoTopicChange = (nextKey) => {
    const next = new URLSearchParams(location.search || '');
    next.set('topic', nextKey);
    if (useStaticScene) next.set('static', '1');
    navigate(`${location.pathname}?${next.toString()}`, { replace: true });
  };

  return (
    <LessonDemo
      forcedPresentationMode="scene"
      standalone
      initialTopic={useStaticScene ? selectedDemoTopic.request.topic : ''}
      topicEditable={!useStaticScene}
      staticSceneData={useStaticScene ? selectedDemoTopic.staticSceneData : null}
      staticSceneRequest={useStaticScene ? selectedDemoTopic.request : null}
      demoTopicOptions={useStaticScene ? demoTopicOptions : []}
      selectedDemoTopicKey={useStaticScene ? selectedDemoTopic.key : ''}
      onDemoTopicChange={useStaticScene ? handleDemoTopicChange : null}
    />
  );
};

export default SceneLessonPage;
